"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigurationError = exports.PaymentStateError = exports.SecurityBoundaryError = exports.DataIntegrityError = exports.UserBlockingError = void 0;
// Phase 123 Plan 02 Task 1 — SEV1 subclasses (user-blocking / product broken).
//
// SEV1 = a human was waiting for this and it failed unexpectedly. Triggers
// ntfy phone push via the single Sentry alert rule on `severity:sev1`.
// All 5 classes default to httpStatus 500; the filter (Plan 04) preserves the
// sanitized `SAFE_MESSAGE_BY_STATUS[500]` body and sets Sentry level `fatal`.
const base_1 = require("./base");
/** Default wrapper for any unexpected failure in a request handler, OAuth flow, or CLI command where a user is waiting. */
class UserBlockingError extends base_1.AppError {
    static severity = 'sev1';
    static httpStatus = 500;
}
exports.UserBlockingError = UserBlockingError;
/** State divergence, corruption, impossible invariant (e.g., Stripe says paid, DB says unpaid). */
class DataIntegrityError extends base_1.AppError {
    static severity = 'sev1';
    static httpStatus = 500;
}
exports.DataIntegrityError = DataIntegrityError;
/** Auth bypass, encryption/decryption failure on prod data. */
class SecurityBoundaryError extends base_1.AppError {
    static severity = 'sev1';
    static httpStatus = 500;
}
exports.SecurityBoundaryError = SecurityBoundaryError;
/** Stripe ↔ DB disagreement on payment state. */
class PaymentStateError extends base_1.AppError {
    static severity = 'sev1';
    static httpStatus = 500;
}
exports.PaymentStateError = PaymentStateError;
/**
 * Missing critical secret/env/infra state. Existing Phase 90 class brought
 * under `AppError`. The `internalMeta` getter preserves the Phase 90 contract
 * (internal-only; never exposed to clients — see Phase 90 VERIFICATION).
 */
class ConfigurationError extends base_1.AppError {
    static severity = 'sev1';
    static httpStatus = 500;
    /** Phase 90 back-compat alias. Same data as `.details`, different name. */
    get internalMeta() {
        return this.details;
    }
}
exports.ConfigurationError = ConfigurationError;
